'use client';

import { useContext } from 'react';
import { Header as HeaderMarkup } from '@/components/ui/layouts/header/Header';
import { StaticTextContext } from '../context/StaticTextProvider';

export const Header = ({ data, language, socialData, shoppingCartLink }) => {
	const { st } = useContext(StaticTextContext);

	return (
		<>
			<HeaderMarkup
				logoData={{
					href: `/${language || ''}`,
					a11yLabel: 'Logo EOI Header',
				}}
				shopLink={shoppingCartLink}
				menuData={data?.relations?.WebMenu?.[0]}
				menuLangData={data?.relations?.ChangeLanguageList}
				socialData={socialData}
				textAside={st('header.verticalText')}
				texts={{
					exitMenu: st('header.exitMenu'),
					menu: st('header.menu'),
					language: st('header.language'),
					close: st('header.close'),
					menuLanguage: st('header.menuLanguage'),
					menuNav: st('header.menuNav'),
					navigation: st('header.navigation'),
					cart: 'Anar a la meva cistella',
				}}
				currentLanguage={language}
			/>
		</>
	);
};
